/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".interstitial-modal[_ngcontent-%COMP%]{color:var(--interstitial-modal-content-color,inherit)}.interstitial-modal[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;margin-top:15px;padding-top:15px;border-top:var(--interstitial-modal-border-top,1px solid var(--finder-detail-grey))}.interstitial-modal[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]   .cancel-button[_ngcontent-%COMP%]{margin-right:15px}"];
export { styles as styles };
